import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import consumerService from '../services/consumer.service';

export interface ConsumerState {
  consumptionOverview?: any,
}

const initialState: ConsumerState = {
  consumptionOverview: {}
};

export const consumptionOverviewAsync = createAsyncThunk(
  'consumer/overview',
  async (params: any) => {
    const response = await consumerService.getConsumptionOverviewData(
      params.consumerId, params.year, params.month, params.meterType
    );
    return response.data;
  }
);

export const consumerSlice = createSlice({
  name: 'consumer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(consumptionOverviewAsync.pending, (state) => {       
      })
      .addCase(consumptionOverviewAsync.fulfilled, (state, action) => {       
        state.consumptionOverview = action.payload[0];
      })
      .addCase(consumptionOverviewAsync.rejected, (state) => {
      });
  },
});



export const selectConsumptionOverview = (state: RootState): any => state.consumer.consumptionOverview;

export default consumerSlice.reducer;